<template>
  <footer class="footer footer-static footer-light navbar-shadow" style="background: #bf9f62;color:white">
      <p class="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2 container center-layout" style="color:white"><span class="float-md-center d-block d-md-inline-block" style="color:white">Copyright  &copy; 2019 <a href="https://ar.ug.edu.gh" target="_blank" class="text-bold-800 white darken-2">UGCS </a>, All rights reserved. </span><span class="float-md-right d-block d-md-inline-blockd-none d-lg-block"></span></p>
    </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
<style scoped>

</style>
